const style = `
.empty_dialog-wrapper {
    align-items: center;
    justify-content: center;
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 1000;
}

.empty_dialog-overlay {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, .8);
}

.empty_dialog {
    box-shadow: 1px 2px 8px #ccc;
    z-index: 1001;
    max-width: 90vw;
    max-height: 90vh;
    width: 600px;
    background-color: white;

}



@media(min-width: 600px) {
    .empty_dialog {
        left: calc(50% - 300px);
    }
}

@media(min-height: 300px) {
    .empty_dialog {
        top: calc(50% - 150px);
    }
}


.empty_dialog .empty_dialog__message {
    padding: 10px;
    box-sizing: border-box;
}

`;
const elem = document.createElement("style");
elem.textContent = style;
document.head.appendChild(elem);